<template>
  <div class="wrapper white-content" :class="{ 'sidebar-collapsed': !$sidebar.showSidebar }">
    <side-bar :sidebar-links="sidebarLinks"> </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <admin-content @click.native="toggleSidebar">
      </admin-content>
    </div>
  </div>
</template>
<script>

import TopNavbar from "./TopNavbar.vue";
import AdminContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  computed: {
    sidebarLinks() {
      return [
        { path: '/admin/dashboard', name: 'Dashboard', icon: 'tim-icons icon-chart-bar-32' },
        { path: '/admin/agencies', name: 'Partners', icon: 'tim-icons icon-world' },
        { path: '/admin/top-placements', name: 'TOP Clinics', icon: 'tim-icons icon-trophy' },
        { path: '/admin/clinics', name: 'Clinics', icon: 'tim-icons icon-bank' },
        { path: '/admin/partner-videos', name: 'Відео партнерів', icon: 'tim-icons icon-video-66' },
        { path: '/admin/doctors', name: 'Doctors', icon: 'tim-icons icon-single-02' },
        { path: '/admin/offers', name: 'Offers', icon: 'tim-icons icon-tag' },
        { path: '/admin/specialities', name: 'Specialities', icon: 'fa fa-user-md' },
        { path: '/admin/clinic/content-moderation', name: 'Content Moderation', icon: 'tim-icons icon-notes' },
        { path: '/admin/static-pages', name: 'Static pages', icon: 'fa fa-file-alt' },
        { path: '/admin/accreditations', name: 'Accreditations', icon: 'fa fa-certificate' },
        { path: '/admin/illness-kinds', name: 'Specialties', icon: 'fa fa-heartbeat' },
        { path: '/admin/illnesses', name: 'Illnesses', icon: 'fa fa-disease' },
        { path: '/admin/operations', name: 'Operations', icon: 'fa fa-user-md' },
        { path: '/admin/diagnostics', name: 'Diagnostics', icon: 'fa fa-stethoscope' },
        { path: '/admin/countries', name: 'Countries', icon: 'fa fa-city' },
        { path: '/admin/cities', name: 'Cities', icon: 'fa fa-city' },
        { path: '/admin/reviews', name: 'Reviews', icon: 'tim-icons icon-chat-33' },
        { path: '/admin/unlink-requests', name: 'Unlink requests', icon: 'tim-icons icon-chat-33' },
        { path: '/admin/offer-services', name: 'Offer services', icon: 'fa fa-medkit' },
        { path: '/admin/offer-questions', name: 'Offer questions', icon: 'fa fa-question-circle' },
        { path: '/admin/articles', name: 'Articles', icon: 'tim-icons icon-book-bookmark' },
        { path: '/admin/custom-pages', name: 'Custom pages', icon: 'tim-icons icon-html5' },
        { path: '/admin/media-images', name: 'Image storage', icon: 'tim-icons icon-image-02' },
        { path: '/admin/manual-seo', name: 'SEO by URLs', icon: 'tim-icons icon-link-72' },
        { path: '/admin/employees', name: 'Employees', icon: 'tim-icons icon-badge' },
        { path: '/admin/help-center/list', name: 'Help center', icon: 'tim-icons icon-paper' },
        { path: '/admin/help-center-categories/list', name: 'Help center categories', icon: 'tim-icons icon-paper' },
      ];
    }
  },
  components: {
    TopNavbar,
    AdminContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>
